import { render, staticRenderFns } from "./StepFlowFooter.vue?vue&type=template&id=0fbe923f&scoped=true"
import script from "./StepFlowFooter.vue?vue&type=script&lang=js"
export * from "./StepFlowFooter.vue?vue&type=script&lang=js"
import style0 from "./StepFlowFooter.vue?vue&type=style&index=0&id=0fbe923f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbe923f",
  null
  
)

export default component.exports